export const workTraderData = {
  buttons: [
    {
      label: 'Yes',
      id: 'yes',
    },
    {
      label: 'No',
      id: 'no',
    },
  ],
  title: 'Was the work in question carried out by a Which? trusted trader?',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/c9a3e159391e-toolicontrustedtrader.jpg',
  },
}
